module.exports = __webpack_public_path__ + "static/media/footer_youtube_hover.b574d38e.svg";